import commonsEn from './translations-commons.json';
import operatorsEn from './translations-operators.json';
import settingsEn from './translations-settings.json';
import trainingsEn from './translations-trainings.json';
import devicesEn from './translations-devices.json';
import globalEn from './translations-global.json';
import materialManagementEn from './translations-material-management.json';

export const translations = {
    ...commonsEn,
    ...operatorsEn,
    ...trainingsEn,
    ...devicesEn,
    ...settingsEn,
    ...globalEn,
    ...materialManagementEn,
};
